import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React, { Suspense } from "react";
import { createRoot } from "react-dom/client"; // <-- updated import
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./i18n";
import "./style.scss";

const container = document.getElementById("root");
if (!container) throw new Error("Root container not found");

const root = createRoot(container); 
root.render(
  <React.StrictMode>
    <Suspense fallback={<div></div>}>
      <App />
    </Suspense>
  </React.StrictMode>
);

// Service worker registration/unregistration
serviceWorker.unregister();